export default __webpack_public_path__ + "static/media/img (1).17d34b1d.jpg";